import { debounce } from 'lodash-es'
import { useCallback, useMemo, useState } from 'react'
import { useTackAutocomplete } from 'src/services/orpc/tack'

export type UseSearchTagInput = {
  limit: number
}

export const useSearchTag = (input?: UseSearchTagInput) => {
  const [inputValue, setInputValue] = useState('')
  const [keyword, setKeyword] = useState('')

  const debouncedSetKeyword = useMemo(
    () => debounce((v: string) => setKeyword(v), 200),
    [],
  )

  const onInputValueChange = useCallback(
    (value: string) => {
      setInputValue(value)
      debouncedSetKeyword(value)
    },
    [debouncedSetKeyword],
  )

  const { tags, isLoading } = useTackAutocomplete(keyword, {
    limit: input?.limit || 20,
  })

  return {
    inputValue,
    onInputValueChange,
    tags,
    loading: isLoading,
  }
}
